'use es6';

import { Map as ImmutableMap } from 'immutable';
import { createReducer } from '../request/redux-request';
import { fetchUsersActions } from './users-action';
export const usersReducer = createReducer(fetchUsersActions, ImmutableMap());